module.exports = __webpack_public_path__ + "media/images/icons/outlined/radius-bottomright-cd0ee525d1651d2904ad4fdc4f2f5823.svg";